import React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, IconButton, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ButtonView } from '../../../components/Button';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export interface DialogTitleProps5 {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps5) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

export const ApproveConfirmationBox = (props: any) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const submitClick=()=>{
        if(props.mode === 'generate'){
            props.updateQuoteApi('isSubmitButton');
            props.updateItemStatus(true);
            props.onClose();
        }
    }

    return (
        <div>
            <BootstrapDialog
                onClose={props.onClose}
                aria-labelledby={props.labelledby}
                open={props.open}
                fullScreen={fullScreen}
                fullWidth={true}
                sx={{ padding: 10 }}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={props.onClose}>
                </BootstrapDialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        {props.message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <ButtonView variant="contained" name='Yes' color="primary" onClick={() => submitClick()} />
                    <ButtonView variant="outlined" name='No' color="error" onClick={props.onClose} />
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}
